import type { HTTPValidationError } from '@/shared/generated'

import { useTranslation } from 'react-i18next'

import {
	Table,
	TableBody,
	TableCell,
	TableRow,
} from '@/shared/components/ui/table'

export function ValidationErrorsList({
	errors,
}: {
	errors: HTTPValidationError['detail']
}) {
	const { t } = useTranslation()

	return (
		<div className='relative max-h-[300px] overflow-hidden overflow-y-auto rounded-md border'>
			<Table data-slot='table' className='text-left text-sm'>
				<TableBody>
					{errors?.map((error) => (
						<TableRow key={error.loc.join('.')}>
							<TableCell className='w-32 bg-muted/50 font-mono text-xs font-medium text-primary'>
								{error.loc.join('.')}
							</TableCell>
							<TableCell className='text-xs text-destructive'>
								{t(error.msg, {
									ns: 'errors',
									defaultValue: error.msg,
								})}
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	)
}
